import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/interpreter';
import Users from './InterpreterCrear';
import {resetStore} from "../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.interpreter,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(Users);
